import { Shimmer } from 'react-shimmer'

import type { GetInternalActionExecutionLogByIdResponse } from '~/generated/client'
import { upperCaseFirstLetter } from '~/utils/string'
import { Badge, Logo, Tag } from '../components/common'

export const LogHeaderStart = ({
  data,
}: {
  data: GetInternalActionExecutionLogByIdResponse
}) => {
  const actionId = data?.actionId
  const version = data?.version
  const status = data?.status
  const icon = data?.app?.icon
  return (
    <div className="flex items-center justify-between !px-[16px] !pt-[12px]">
      <div className="flex items-center gap-2">
        {!data ? (
          <Shimmer width={300} height={20} />
        ) : (
          <>
            <Logo url={icon} size={20} />
            <div className="ds-text-16 ds-ml-4 ds-text-black-800 ds-font-text ds-font-500 ds-no-wrap">
              {upperCaseFirstLetter(
                actionId.toLocaleLowerCase().split('_').join(' '),
              )}
            </div>
            <Tag>v{version}</Tag>
          </>
        )}
      </div>
      <div className="ds-flex ds-items-center ds-gap-6">
        {!data ? (
          <Shimmer width={50} height={20} />
        ) : (
          <Badge state={status === 'error' ? 'error' : 'success'}>
            <span className="ds-mb-1 ds-text-13 ds-font-500">
              {upperCaseFirstLetter(status)}
            </span>
          </Badge>
        )}
      </div>
    </div>
  )
}
